module.exports = __webpack_public_path__ + "media/images/salles de réunions-62817228e2283c2f842c49601d9c238a.svg";